export default "__VITE_ASSET__46717eea__"